
import { formatDateForDisplay,formatCellValue, formatPhoneNumber } from "../../Utils/UtilityFunctions";
const useReservationColumns = (allDate, allName, allNumber, allstationadress, startDuration, endDuration, allstationName, finalData, allres) => {
    return [
        {
            accessorFn: (allres, index) => `${allName[index]}`,
            header: 'Customer',
              Cell: ({ cell }) => formatCellValue(cell.getValue())           
        },
        {
            accessorFn: (allres, index) => `${allNumber[index]}`,
            header: 'Phone Number',
              Cell: ({ cell }) => formatCellValue(formatPhoneNumber(`${cell.getValue()}`))
        },
        {
            accessorFn: (station, index) => `${allstationName[index]}`,
            header: 'Station Name',
              Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (station, index) => `${allstationadress[index]}`,
            header: 'Station Address',
              Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (customer, index) => `${startDuration[index]} - ${endDuration[index]}`,
            header: 'Duration',
              Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (customer, index) => `${allDate[index]}`,
            header: 'Date',
            Cell: ({ cell }) => formatCellValue(cell.getValue(),val=> formatDateForDisplay(val))
        },
        {
            accessorFn: (customer, index) => `${finalData[index].connectorType}`,
            header: 'Connector Type',
              Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
        {
            accessorFn: (customer, index) => `${finalData[index].evseId}`,
            header: 'Evse',
              Cell: ({ cell }) => formatCellValue(cell.getValue())
        },
    ];
};

export default useReservationColumns;
